import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { formatNumber } from "../../utils/common";
import { useTranslation } from "react-i18next";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

function BarVeritical({ data }) {
  const { i18n } = useTranslation();
  const language = i18n.language;
  const labels = data.map((item) => item.year);
  const dataObj = data.map((item) => Math.floor(item.amount));

  const backgroundColors = dataObj.map((value) => "#0080B7");

  const chartData = {
    labels,
    datasets: [
      {
        label: "",
        data: dataObj,
        backgroundColor: backgroundColors,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 25, // adjust this value as needed to provide enough room for the labels
      },
    },
    scales: {
      x: {
        grid: {
          drawOnChartArea: false,
          drawBorder: false,
          display: false,
        },
        ticks: {
          color: "black",
        },
      },
      y: {
        beginAtZero: true,
        maxTicksLimit: 5,
        ticks: {
          display: true,
        },
        grid: {
          drawBorder: false,
          display: false, // This hides the horizontal grid lines
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            var label = context.dataset.label || "";

            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += formatNumber(context.parsed.y, language) + "€";
            }
            return label;
          },
        },
      },
      datalabels: {
        anchor: "end",
        align: "top",
        formatter: function (value, context) {
          return formatNumber(value.toString(), language);
        },
        color: "black",
        font: {
          size: 10,
        },
      },
    },
  };

  return <Bar options={options} data={chartData} />;
}

export default BarVeritical;
